import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "table table-hover align-middle mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "border-dark border-bottom pb-2" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-dark border-bottom" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, /*#__PURE__*/_toDisplayString('Naam')),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, /*#__PURE__*/_toDisplayString('Referentie')),
    /*#__PURE__*/_createElementVNode("th", null, /*#__PURE__*/_toDisplayString('Doel')),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  colspan: 6,
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_MenusOverviewItem = _resolveComponent("MenusOverviewItem")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      (this.menuUi.isNotReady())
        ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
            key: 0,
            "n-cols": 6
          }))
        : _createCommentVNode("", true),
      (this.menuUi.isReady() && !this.hasMenuItems)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t('noContentFound')), 1)
          ]))
        : _createCommentVNode("", true),
      (this.menuUi.isReady() && this.hasMenuItems)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(this.menuItems, (menuItem) => {
            return (_openBlock(), _createBlock(_component_MenusOverviewItem, {
              key: menuItem.id,
              "menu-id": this.menuId,
              "full-menu-item": menuItem,
              "is-sub-menu": this.isSubMenu,
              onExceptions: this.setExceptions,
              onDelete: this.deleteItem,
              onMove: this.moveItem
            }, null, 8, ["menu-id", "full-menu-item", "is-sub-menu", "onExceptions", "onDelete", "onMove"]))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ]))
}